import { ScrcpyOptions1_23 } from "./1_23.js";
export class ScrcpyOptions1_24 extends ScrcpyOptions1_23 {
    constructor(init) {
        super(init);
    }
    getDefaultValue() {
        return {
            ...super.getDefaultValue(),
            powerOn: true,
        };
    }
}
//# sourceMappingURL=1_24.js.map